import { useCallback, useMemo, ReactNode } from 'react';
import { MutationActionCreatorResult } from '@reduxjs/toolkit/query';
import { MonitoringTableContext } from './useMonitoringTableContext';

export interface MonitoringTableProviderProps {
  children: ReactNode;
  onUpdateFollowUp?: (props: {
    id: number;
    hasFollowUp: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => void | MutationActionCreatorResult<any>;
  selectedIds: Set<number>;
  onSelectionChange: (selectedIds: Set<number>) => void;
}

export const MonitoringTableProvider = ({
  children,
  onUpdateFollowUp,
  selectedIds,
  onSelectionChange,
}: MonitoringTableProviderProps) => {
  const toggleSelection = useCallback(
    (id: number, checked: boolean) => {
      const next = new Set(selectedIds);
      if (checked) {
        next.add(id);
      } else {
        next.delete(id);
      }
      onSelectionChange(next);
    },
    [selectedIds, onSelectionChange]
  );

  const isSelected = useCallback((id: number) => selectedIds.has(id), [selectedIds]);

  const value = useMemo(
    () => ({
      selectedIds,
      selectedCount: selectedIds.size,
      isSelected,
      toggleSelection,
      onUpdateFollowUp,
    }),
    [selectedIds, isSelected, toggleSelection, onUpdateFollowUp]
  );

  return (
    <MonitoringTableContext.Provider value={value}>{children}</MonitoringTableContext.Provider>
  );
};
